import React, { useEffect } from 'react';

const HomePageBackground: React.FC = () => {
  useEffect(() => {
    // Get the app-background element
    const appBackground = document.querySelector('.app-background') as HTMLElement;

    if (appBackground) {
      // Store the original background
      const originalBackground = appBackground.style.backgroundImage;
      const originalBackgroundColor = appBackground.style.backgroundColor;

      // Set a bright, professional gradient background
      appBackground.style.backgroundImage = 'linear-gradient(135deg, #0a2540 0%, #1a4980 50%, #2d6bb1 100%)';
      appBackground.style.backgroundSize = 'cover';
      appBackground.style.backgroundPosition = 'center';

      // Add a subtle pattern overlay
      const overlay = document.createElement('div');
      overlay.className = 'home-background-overlay';
      overlay.style.position = 'absolute';
      overlay.style.top = '0';
      overlay.style.left = '0';
      overlay.style.width = '100%';
      overlay.style.height = '100%';
      overlay.style.backgroundImage = 'url("data:image/svg+xml,%3Csvg width=\'100\' height=\'100\' viewBox=\'0 0 100 100\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z\' fill=\'%23ffffff\' fill-opacity=\'0.05\' fill-rule=\'evenodd\'/%3E%3C/svg%3E")';
      overlay.style.backgroundSize = '150px 150px';
      overlay.style.opacity = '0.5';
      overlay.style.zIndex = '-1';
      appBackground.appendChild(overlay);

      // Add a subtle light effect
      const lightEffect = document.createElement('div');
      lightEffect.className = 'home-light-effect';
      lightEffect.style.position = 'absolute';
      lightEffect.style.top = '0';
      lightEffect.style.left = '0';
      lightEffect.style.width = '100%';
      lightEffect.style.height = '100%';
      lightEffect.style.background = 'radial-gradient(circle at 30% 20%, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0) 60%)';
      lightEffect.style.zIndex = '-1';
      appBackground.appendChild(lightEffect);

      // Add a subtle animation
      const style = document.createElement('style');
      style.innerHTML = `
        @keyframes pulse {
          0% { opacity: 0.5; }
          50% { opacity: 0.7; }
          100% { opacity: 0.5; }
        }
        .home-background-overlay {
          animation: pulse 15s ease-in-out infinite;
        }
      `;
      document.head.appendChild(style);

      // Restore the original background when component unmounts
      return () => {
        appBackground.style.backgroundImage = originalBackground;
        appBackground.style.backgroundColor = originalBackgroundColor;
        if (overlay.parentNode) {
          appBackground.removeChild(overlay);
        }
        if (lightEffect.parentNode) {
          appBackground.removeChild(lightEffect);
        }
        if (style.parentNode) {
          document.head.removeChild(style);
        }
      };
    }
  }, []);

  // This component doesn't render anything visible
  return null;
};

export default HomePageBackground;
